import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import heroSkillHub from '../../../assets/images/heroSkillHub.jpg';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToDemo = () => {
    const featuresSection = document.getElementById('features');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToContact = () => {
    navigate('/lien-he');
  };

  // Fake avatars với initials
  const avatars = [
    { name: 'Nguyễn Văn A', initial: 'NA', color: 'from-blue-500 to-cyan-500' },
    { name: 'Trần Thị B', initial: 'TB', color: 'from-purple-500 to-pink-500' },
    { name: 'Lê Văn C', initial: 'LC', color: 'from-green-500 to-emerald-500' },
    { name: 'Phạm Thị D', initial: 'PD', color: 'from-orange-500 to-red-500' }
  ];

  return (
    <section className="relative min-h-screen bg-gradient-to-br from-blue-50 via-white to-cyan-50 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, #06b6d4 2px, transparent 0)`,
          backgroundSize: '32px 32px',
          opacity: 0.1
        }}></div>
      </div>

      {/* Floating Gradient Orbs */}
      <div className="absolute top-20 right-20 w-96 h-96 bg-gradient-to-r from-[#2a5bd7]/20 to-[#06b6d4]/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 left-20 w-80 h-80 bg-gradient-to-r from-[#2ecc71]/20 to-[#06b6d4]/20 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>

      <div className="relative container mx-auto px-6 min-h-screen">
        <div className="grid lg:grid-cols-12 gap-8 items-center min-h-screen py-20">
          {/* Left Content - 5 columns */}
          <div className="lg:col-span-5 space-y-8 relative z-10">
            {/* Trust Badge */}
            <div className={`inline-flex items-center bg-white/90 backdrop-blur-sm border border-[#2a4b7c]/20 px-6 py-3 rounded-full shadow-lg transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
            }`}>
              <div className="w-6 h-6 bg-[#2ecc71] rounded-full flex items-center justify-center mr-3">
                <i className="ri-star-fill text-white text-sm"></i>
              </div>
              <span className="text-[#3d5a80] font-medium text-sm">Được xây dựng dựa trên bài toán thực tế doanh nghiệp</span>
            </div>

            {/* Main Headlines */}
            <div className={`space-y-6 transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}>
              <h1 className="text-6xl lg:text-7xl font-black leading-none">
                <span className="text-[#2a4b7c]">Biến</span><br/>
                <span className="text-[#3d5a80]">
                  Kỹ năng
                </span><br/>
                <span className="text-[#2a4b7c]">thành</span>
                <span className="relative ml-4">
                  <span className="text-[#06b6d4]">Lợi thế</span>
                  <div className="absolute -bottom-2 left-0 w-full h-3 bg-[#06b6d4]/30 -z-10 rounded-lg"></div>
                </span>
              </h1>
            </div>

            {/* Description */}
            <div className={`space-y-4 transition-all duration-1000 delay-400 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}>
              <p className="text-xl text-slate-700 leading-relaxed max-w-lg font-medium">
              <span className="font-bold text-[#2a4b7c]">StackWay Skill Hub</span> là nền tảng SaaS giúp doanh nghiệp
              </p>
              <div className="flex flex-wrap gap-2 text-lg">
                <span className="bg-[#2a4b7c] text-white px-4 py-2 rounded-full font-semibold hover:scale-105 transition-transform duration-300">Hiểu đúng</span>
                <span className="text-slate-400">→</span>
                <span className="bg-[#06b6d4] text-white px-4 py-2 rounded-full font-semibold hover:scale-105 transition-transform duration-300">Đo chính xác</span>
                <span className="text-slate-400">→</span>
                <span className="bg-[#00c897] text-white px-4 py-2 rounded-full font-semibold hover:scale-105 transition-transform duration-300">Phát triển</span>
              </div>
              <p className="text-slate-600">khai thác hiệu quả năng lực (skill) của đội ngũ nhân sự, từ đó đưa ra quyết định đúng về tuyển dụng, đào tạo, phân công dự án và phát triển nghề nghiệp.</p>
            </div>

            {/* CTA Buttons */}
            <div className={`flex flex-col sm:flex-row gap-4 pt-4 transition-all duration-1000 delay-600 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}>
              <button 
                onClick={scrollToDemo}
                className="group bg-gradient-to-r from-[#2a4b7c] to-[#3d5a80] text-white px-8 py-4 rounded-2xl font-bold text-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-3 text-xl"></i>
                Xem Demo Ngay
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </button>
              <button 
                onClick={goToContact}
                className="bg-white/80 backdrop-blur-sm border-2 border-[#2a4b7c]/30 text-[#3d5a80] px-8 py-4 rounded-2xl font-bold text-lg hover:bg-white hover:shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-line mr-2"></i>
                Tư vấn miễn phí
              </button>
            </div>

            {/* Trust Indicators */}
            <div className={`flex items-center space-x-4 pt-4 transition-all duration-1000 delay-800 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}>
              <div className="flex -space-x-2">
                {avatars.map((avatar, i) => (
                  <div 
                    key={i} 
                    className="w-10 h-10 rounded-full border-2 border-white shadow-lg bg-gradient-to-br hover:scale-110 transition-transform duration-300 flex items-center justify-center text-white text-xs font-bold"
                    style={{ transitionDelay: `${i * 50}ms` }}
                    title={avatar.name}
                  >
                    <div className={`w-full h-full rounded-full bg-gradient-to-br ${avatar.color} flex items-center justify-center`}>
                      {avatar.initial}
                    </div>
                  </div>
                ))}
              </div>
              <div>
                <p className="font-semibold text-[#2a4b7c] text-sm">2,000+ HR Leader</p>
                <p className="text-xs text-slate-600">đã tham gia cộng đồng</p>
              </div>
            </div>
          </div>

          {/* Right Visual - 7 columns */}
          <div className={`lg:col-span-7 relative transition-all duration-1000 delay-500 z-0 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
          }`}>
            <div className="relative">
              {/* Main Dashboard Mockup */}
              <div className="relative transform rotate-3 hover:rotate-0 transition-transform duration-700 hover:scale-105">
                <div className="bg-white rounded-3xl shadow-2xl p-8 backdrop-blur-sm border border-[#2a4b7c]/10">
                  <img 
                    src={heroSkillHub}
                    alt="Stackway Skill Hub Dashboard"
                    className="w-full h-auto rounded-xl"
                  />
                </div>
              </div>

              {/* Floating Cards */}
              <div className="absolute -top-8 -left-12 animate-float">
                <div className="bg-white rounded-2xl shadow-xl p-6 border border-[#06b6d4]/20 max-w-xs">
                  <div className="flex items-center space-x-3 mb-3">
                    <div className="w-10 h-10 bg-[#2ecc71] rounded-xl flex items-center justify-center">
                      <i className="ri-code-s-slash-line text-white"></i>
                    </div>
                    <div>
                      <p className="font-bold text-[#2a4b7c]">Năng lực phân tích
                      </p>
                      <p className="text-sm text-slate-500">Expert Level</p>
                    </div>
                  </div>
                  <div className="w-full bg-slate-200 rounded-full h-2">
                    <div className="bg-[#2ecc71] h-2 rounded-full w-11/12"></div>
                  </div>
                </div>
              </div>

              <div className="absolute -bottom-6 -right-8 animate-float" style={{animationDelay: '0.5s'}}>
                <div className="bg-white rounded-2xl shadow-xl p-6 border border-[#2a5bd7]/20">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-[#2a4b7c] rounded-full flex items-center justify-center">
                      <i className="ri-notification-2-line text-white text-sm"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-[#2a4b7c] text-sm">5 kỹ năng mới</p>
                      <p className="text-xs text-slate-500">được cập nhật</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute top-1/2 -right-16 animate-float" style={{animationDelay: '1s'}}>
                <div className="bg-gradient-to-r from-[#2a4b7c] to-[#3d5a80] rounded-2xl shadow-xl p-6 text-white text-center min-w-[120px]">
                  <div className="flex items-center justify-center mb-2">
                    <span className="text-3xl font-black">127%</span>
                    <i className="ri-arrow-up-line ml-1"></i>
                  </div>
                  <p className="text-sm opacity-90">Tăng trưởng</p>
                  <p className="text-xs opacity-75">năng lực</p>
                  <div className="flex justify-center mt-2">
                    <i className="ri-sparkling-2-line text-[#2ecc71]"></i>
                  </div>
                </div>
              </div>

              {/* Geometric Decorations */}
              <div className="absolute top-20 left-20 w-20 h-20 border-2 border-[#06b6d4]/30 rounded-full opacity-30 animate-spin-slow"></div>
              <div className="absolute bottom-32 left-8 w-8 h-8 bg-[#2ecc71]/40 transform rotate-45"></div>
              <div className="absolute top-40 right-20 w-12 h-12 border-2 border-[#2a5bd7]/30 transform rotate-12"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 border-2 border-[#3d5a80] rounded-full flex justify-center">
          <div className="w-1 h-3 bg-[#2a5bd7] rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
